import {
  UserActivityAnalyticsPage,
  normalizeUserActivityPageTab,
  type UserActivityAdminApi,
  type UserActivityPageTab
} from '@jarvis/platform-ui';
import { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import {
  getClientPortalUserActivityAnalytics,
  getClientPortalUserActivityLive,
  getClientPortalUserActivitySummary,
  listClientPortalUserActivitySessions
} from '../../../api/clientPortalUserActivity';

const clientPortalUserActivityApi: UserActivityAdminApi = {
  getLive: getClientPortalUserActivityLive,
  getAnalytics: getClientPortalUserActivityAnalytics,
  getSummary: getClientPortalUserActivitySummary,
  listSessions: listClientPortalUserActivitySessions
};

export function ClientPortalUserActivitySummaryPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialTab = normalizeUserActivityPageTab(tabParam) ?? undefined;

  const onTabChange = useCallback(
    (tab: UserActivityPageTab) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (tab === 'summary') next.delete('tab');
          else next.set('tab', tab);
          return next;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return (
    <UserActivityAnalyticsPage
      api={clientPortalUserActivityApi}
      showTenantColumn
      stateStorageKey="webopsui:client-portal-user-activity-history-grid"
      prefsStorageKey="webops-client-portal-user-activity-ui"
      initialTab={initialTab}
      onTabChange={onTabChange}
    />
  );
}

export function ClientPortalUserActivityHistoryRedirectPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/admin/client-portal/user-activity?tab=sessions', { replace: true });
  }, [navigate]);
  return null;
}
